/* Cellovi: Microsoft Clarity, loaded only when the visitor's privacy choices allow analytics and sale of data is not
   opted out (Global Privacy Control sets that opt-out). The theme never adds this file to the quiz, contact, health data,
   data sharing opt-out, birthday or account pages; the path check below is a second guard.
   Once allowed, it loads after the page is usable (first interaction, or 3 s after load), tells Clarity that analytics
   storage is granted and ad storage is denied, and Clarity masks what visitors type. */
(function () {
  var me = document.currentScript, id = me && me.getAttribute('data-cl');
  if (!id) return;
  if (/^\/(pages\/(quiz|contact|consumer-health-data|data-sharing-opt-out|birthday)|account)(\/|$)/.test(location.pathname)) return;
  var done = false, armed = false, ev = ['pointerdown', 'keydown', 'scroll', 'touchstart'];
  function go() {
    if (done) return; done = true;
    ev.forEach(function (e) { removeEventListener(e, go); });
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(i);
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', id);
    try { window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' }); } catch (e) {}
  }
  function arm() {
    if (armed) return; armed = true;
    ev.forEach(function (e) { addEventListener(e, go, { passive: true }); });
    if (document.readyState === 'complete') setTimeout(go, 3000);
    else addEventListener('load', function () { setTimeout(go, 3000); });
  }
  function ok(cp) {
    try { return cp.analyticsProcessingAllowed() && cp.saleOfDataAllowed(); } catch (e) { return false; }
  }
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = e.detail || {};
    if (d.analyticsAllowed && d.saleOfDataAllowed !== false) arm();
  });
  function check() {
    var S = window.Shopify;
    if (!S || !S.loadFeatures) return false;
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err && S.customerPrivacy && ok(S.customerPrivacy)) arm();
    });
    return true;
  }
  if (!check()) addEventListener('load', check);
})();
